import { maAuthenticationGuard } from '@/router/guards'
import { RouteName } from '@/base/constants/route'

const onboardingRoutes = {
  path: '/onboarding',
  name: RouteName.ONBOARDING,
  meta: {
    title: 'Onboarding',
  },
  redirect: { name: RouteName.ONBOARDING_WELCOME },
  component: () => import('@/pages/main/layout/Onboarding.vue'),
  beforeEnter: maAuthenticationGuard,
  children: [
    {
      path: 'welcome',
      name: RouteName.ONBOARDING_WELCOME,
      meta: {
        title: 'Welcome',
        analyticsPageName: 'Onboarding - Welcome',
      },
      component: () => import('@/pages/onboarding/MaOnboardingStepWelcome.vue'),
    },
    {
      path: 'select-app',
      name: RouteName.ONBOARDING_SELECT_APP,
      meta: {
        title: 'Select App',
        analyticsPageName: 'Onboarding - Select App',
      },
      component: () => import('@/pages/onboarding/MaOnboardingStepSelectApp.vue'),
    },
    {
      path: 'select-competitors',
      name: RouteName.ONBOARDING_SELECT_COMPETITORS,
      meta: {
        title: 'Select Competitors',
        analyticsPageName: 'Onboarding - Select Competitors',
      },
      components: {
        default: () => import('@/pages/onboarding/MaOnboardingStepSelectCompetitors.vue'),
        sidebar: () => import('@/pages/onboarding/MaOnboardingSidebar.vue'),
      },
    },
    {
      path: 'select-keywords',
      name: RouteName.ONBOARDING_SELECT_KEYWORDS,
      meta: {
        title: 'Select Keywords',
        analyticsPageName: 'Onboarding - Select Keywords',
      },
      components: {
        default: () => import('@/pages/onboarding/MaOnboardingStepSelectKeywords.vue'),
        sidebar: () => import('@/pages/onboarding/MaOnboardingSidebar.vue'),
      },
    },
    {
      path: 'pricing',
      name: RouteName.ONBOARDING_PRICING,
      meta: {
        title: 'Pricing',
        analyticsPageName: 'Onboarding - Pricing',
      },
      components: {
        default: () => import('@/pages/onboarding/MaOnboardingStepPricing.vue'),
      },
    },
    {
      path: 'payment',
      name: RouteName.ONBOARDING_PAYMENT,
      meta: {
        title: 'Payment',
        analyticsPageName: 'Onboarding - Payment',
      },
      components: {
        default: () => import('@/pages/onboarding/MaOnboardingStepPayment.vue'),
      },
    },
    {
      path: 'complete',
      name: RouteName.ONBOARDING_COMPLETE,
      meta: {
        title: 'Complete',
        analyticsPageName: 'Onboarding - Complete',
      },
      components: {
        default: () => import('@/pages/onboarding/MaOnboardingStepComplete.vue'),
        sidebar: () => import('@/pages/onboarding/MaOnboardingSidebar.vue'),
      },
    },
  ],
}

export default onboardingRoutes
